export default __webpack_public_path__ + "static/media/peoTVGO.f6b42ea6.png";